import { FileField_default } from "./chunk-2NBIW5NB.js";
import { FileInput_File_default } from "./chunk-AFIC773Z.js";

// src/components/FileField/index.tsx
var FileFieldComponent = FileField_default;
FileFieldComponent.File = FileInput_File_default;
FileFieldComponent.File.displayName = "FileField.File";
export { FileFieldComponent };